import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { PAYOR, findServiceArea, getAddressDetails, getBrokersList, nonZeroCoordinateValidator } from '../../utils/utils.common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ProTipsServiceService } from 'src/app/component/helping-material/nemt-pro-tips/service/pro-tips-service.service';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';



@Component({
  selector: 'app-partial-edit',
  templateUrl: './partial-edit.component.html',
  styleUrls: ['./partial-edit.component.css']
})
export class PartialEditComponent implements OnInit, OnDestroy {
  @Input() trip: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() updateTripObj = new EventEmitter<any>();
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  payorList = PAYOR;
  isFileLoading = false;
  selectedFile = null;
  pdfAttachment;
  timeZone;
  submitted = false;
  isFarmoutIntegration = false
  user;

  constructor(
    private proTipsService: ProTipsServiceService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private farmoutService: FarmoutService,
    private fb: FormBuilder) { }

  updateTripModalForm: FormGroup;

  ngOnInit() {
    if (this.trip && this.trip._id) {
      this.getTripDetails();
    }
    this.updateTripModalForm = this.fb.group({
      _id: [''],
      authorizationNumber: [''],
      dispatchNoteTwo: [''],
      companyNote: [''],

      preDispatchNoteTwo: [''],
      preCompanyNote: [''],

      attachment: [''],
      status: [''],
      jobStatus: [''],

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeDest: [''],
      isByPassed: [true],
    });

    this.getUser();
  }


  getUser() {
    this.sharedDataService.getUser().subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = data.timeZone;

        if (data.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = data.isFarmout
        }
      }
    })
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }

  uploadFile(selectedPDFFile) {
    this.isFileLoading = true;
    this.proTipsService
      .changeCoverImage(selectedPDFFile)
      .subscribe(data => {
        if (data) {

          this.isFileLoading = false;
          // this.pdfAttachment = data.loaction
          this.updateTripModalForm.patchValue({ attachment: data.location });
        }
      });
  }

  processCoverImageFile(pdfInput: any) {
    imageProcessing(pdfInput)
      .subscribe((result) => {
        this.fileInput.nativeElement.value = '';
        if (result && result.file && result.file.type === "application/pdf") {
          this.uploadFile(result.file);
        } else {
          // this.toastr.success("Invalid file uploaded", 'Alert');
        }
      });
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    this.updateTripModalForm.patchValue({
      jobDestinationAddress: place.formatted_address,
      jobDestinationLatitude: place.geometry.location.lat(),
      jobDestinationLongitude: place.geometry.location.lng(),
      zipCodeDest: zip,
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.updateTripModalForm.invalid) return;
    this.updateTrip(this.updateTripModalForm.value);
  }

  updateTrip(payload) {

    const date = moment().tz(this.timeZone).format("MM/DD/YYYY HH:mm a");

    if (payload.dispatchNoteTwo && payload.preDispatchNoteTwo != payload.dispatchNoteTwo) {
      payload.dispatchNoteTwo = payload.dispatchNoteTwo + ' ' + date
    }

    if (payload.companyNote && payload.preCompanyNote != payload.companyNote) {
      payload.companyNote = payload.companyNote + ' ' + date
    }

    this.assignTripService
      .updateTrip(payload)
      .subscribe(data => {
        if (data) {
          if (this.isFarmoutIntegration && data.farmout && data.farmout.productId && data.farmout.requestId && ['processing', 'accepted', 'arriving', 'in_progress'].includes(data.farmout.status)) {
            this.updateFarmoutTrip(data);
          }

          this.updateTripObj.emit({
            _id: data._id,
            attachment: data.attachment,
            companyNote: data.companyNote,
            dispatchNoteTwo: data.dispatchNoteTwo,
            jobDestinationAddress: data.jobDestinationAddress,
            jobDestinationLatitude: data.jobDestinationLatitude,
            jobDestinationLongitude: data.jobDestinationLongitude,
            zipCodeDest: data.zipCodeDest
          });
          this.closeModal();
        }
      });

  }

  updateFarmoutTrip(data) {
  const myUser = this.user && this.user.company ? this.user.company : this.user;
    return this.farmoutService.rideUpdateRequest(data.farmout.requestId, {
      "company": myUser._id,
      "product_id": data.farmout.productId,
      "trip_id": data.farmout.requestId,
      "dropoff": {
        "latitude": data.jobDestinationLatitude,
        "longitude": data.jobDestinationLongitude
      },
    }).toPromise();
  }

  removeAttachment() {
    this.updateTripModalForm.patchValue({ attachment: '' });
  }

  setDropOffTimeChange(event) {
    this.updateTripModalForm.patchValue({
      appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
    });
  }

  get form() {
    return this.updateTripModalForm.controls;
  }


  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.updateTripModalForm.patchValue({
            ...data,
            preDispatchNoteTwo: data.dispatchNoteTwo,
            preCompanyNote: data.companyNote
          })
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  ngOnDestroy() {

  }
}
